module.exports = __webpack_public_path__ + "media/applicants/goodmorning-f396b536.png";